import React, { useState } from "react";
import { Modal, Button, Form, Row, Col, Card } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { publishImage } from "../../helpers/imageupload";
import { getAsset } from "../../helpers/helper";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import { ClearIcon } from "@mui/x-date-pickers";
import { images } from "../../constants";
import url from "../../config/axios";
import { useSelector } from "react-redux";

const AddCertificateeModal = ({ show, handleClose, handleSave, id,Dataloaderfun }) => {
  const { name } = useSelector((state) => state.user);

  // Main state
  const [userdata, setUserData] = useState({
    userid: name._id,
    certificateArray: [
      {
        name: "",
        issueDate: "",
        img: ""          // ✔ single string
      }
    ]
  });

  const [displayimg, setDisplayimg] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleServiceChange = (e) => {
    const { name, value } = e.target;

    setUserData((prev) => {
      const updatedArray = [...prev.certificateArray];
      updatedArray[0][name] = value;

      return {
        ...prev,
        certificateArray: updatedArray
      };
    });
  };

  // Upload images
  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const uploadedImages = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });

      // uploadedImages = array → take single first image (string)
      const firstImage = uploadedImages[0];

      // Update certificateArray
      setUserData((prev) => {
        const updatedArray = [...prev.certificateArray];
        updatedArray[0].img = firstImage; // ✔ FIXED

        return {
          ...prev,
          certificateArray: updatedArray
        };
      });

      // Display only 1 image
      setDisplayimg([firstImage]);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  // Remove image
  const removeImage = (index) => {
    setDisplayimg([]);

    // Update userdata
    setUserData((prev) => {
      const updatedArray = [...prev.certificateArray];
      updatedArray[0].img = ""; // ✔ Remove image properly

      return {
        ...prev,
        certificateArray: updatedArray
      };
    });
  };

  // API
  const PostUserdata = () => {
    url
      .put(`service/AddCertExpeSer/id/?id=${id}`, userdata)
      .then((res) => {
        if (res.data.success) {
          Dataloaderfun();
          handleClose();
          SuccessNotify("Certificate Added Successfully");
        }
      })
      .catch(() => {
        FailedNotify("Failed to Add Certificate Try Again");
        handleClose();
      });
  };

  return (
    <Modal show={show === 4} onHide={handleClose} centered size="lg">
      <Modal.Header
        className="text-white pt-1 pb-1 "
        style={{ backgroundColor: "#0353A4" }}
        closeButton
      >
        <Modal.Title>Add Certificate</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row>
            <Col lg="6">
              <Form.Group className="mb-3">
                <Form.Label>Certificate Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Name"
                  name="name"
                  onChange={handleServiceChange}
                />
              </Form.Group>
            </Col>

            <Col lg="6">
              <Form.Group className="mb-3">
                <Form.Label>Issue Date</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Issue Date"
                  name="issueDate"
                  onChange={handleServiceChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Expiry Date (Optional)</Form.Label>
            <Form.Control type="text" placeholder="Expiry Date" />
          </Form.Group>

          {/* Image Upload */}
          <Col>
            <Row>
              <Col lg="9" className="me-auto">
                <Row>
                  <Col lg={3} className="mt-2 ms-1">
                    <Card
                      style={{
                        width: "6rem",
                        height: "6rem",
                        position: "relative",
                      }}
                      {...getRootProps()}
                      className="dropzone"
                    >
                      {isUploading ? (
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            background: "rgba(255,255,255,0.7)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            borderRadius: "0.5rem",
                          }}
                        >
                          <div
                            className="spinner-border text-primary"
                            style={{ width: "1.5rem", height: "1.5rem" }}
                          ></div>
                          <small className="mt-1">{uploadProgress}%</small>
                        </div>
                      ) : (
                        <>
                          <Card.Img className="imet-fit" src={images?.AddImage} />
                          <Card.Body>
                            <input
                              type="file"
                              style={{ display: "none" }}
                              {...getInputProps()}
                              multiple
                              autoComplete="off"
                            />
                          </Card.Body>
                        </>
                      )}
                    </Card>
                  </Col>

                  {displayimg.length > 0 && (
                    <Col lg={7} className="mt-1 d-flex">
                      {displayimg.map((image, index) => (
                        <Card
                          key={index}
                          className="me-2 mt-1"
                          style={{
                            width: "6rem",
                            height: "6rem",
                            border: "2px solid",
                            position: "relative",
                          }}
                        >
                          <Card.Img
                            className="imet-fit upload-img mt-0"
                            src={getAsset(image)}
                            alt=""
                            crossOrigin="anonymous"
                          />
                          <div
                            className="close-btnone"
                            onClick={() => removeImage(index)}
                          >
                            <ClearIcon />
                          </div>
                        </Card>
                      ))}
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Col>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="pt-1 pb-1 ps-3 pe-3 font_11 rounded"
          onClick={handleClose}
          style={{
            backgroundColor: "white",
            border: "1px solid red",
            color: "red",
          }}
        >
          Cancel
        </button>
        <button
          className="pt-1 pb-1 ps-3 pe-3 font_11 rounded"
          onClick={PostUserdata}
          style={{
            backgroundColor: "#0353A4",
            border: "1px solid #0353A4",
            color: "white",
          }}
        >
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCertificateeModal;
